import React, { useState } from 'react';
import './Blog.css';

const Blog = () => {
  const [selectedPost, setSelectedPost] = useState(null);

  const blogPosts = [
    {
      id: 1,
      title: 'THE ART OF MINIMALISM',
      date: 'October 12, 2024',
      category: 'Design Trends',
      image: 'https://images.pexels.com/photos/1457842/pexels-photo-1457842.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
      excerpt: 'Why less is more in modern luxury interiors.',
      fullContent: `Minimalism is not about having less; it is about making room for more of what matters. In this article, we explore how clean lines, monochromatic palettes, and functional furniture can create a sense of serenity in your home.
      
      The philosophy of minimalism in interior design is rooted in the idea that every object in a room should serve a purpose or bring joy. By stripping away the unnecessary, we allow the architecture and the key pieces of furniture to truly shine.
      
      Key elements of this style include:
      • Neutral Color Palettes: Whites, beiges, and soft greys.
      • Functional Furniture: Pieces that are both beautiful and practical.
      • Decluttered Spaces: Smart storage solutions are essential.
      
      Adopting a minimalist approach doesn't mean your home has to feel cold or empty. By using warm textures like wood, wool, and linen, you can create a space that is clean yet inviting.`
    },
    {
      id: 2,
      title: 'WARM TONES ARE BACK',
      date: 'November 05, 2024',
      category: 'Color Theory',
      image: 'https://images.pexels.com/photos/3797991/pexels-photo-3797991.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
      excerpt: 'Moving away from grey: Embracing beige and terracotta.',
      fullContent: `For a decade, cool greys dominated the interior design world. Now, we are seeing a massive shift towards warmer tones. Terracotta, oatmeal, beige, and warm woods are taking center stage.
      
      These colors evoke a sense of comfort and grounding that cool tones often lack. As our homes become our sanctuaries, we crave environments that feel like a warm hug.
      
      How to incorporate warm tones:
      • Paint: Swap stark white walls for creamy off-whites.
      • Textiles: Add throw pillows in burnt orange or mustard yellow.
      • Woods: Choose walnut or oak over black or chrome finishes.
      
      Transitioning your space from cool to warm doesn't require a complete renovation. Start small with accessories and lighting to change the mood of the room.`
    },
    {
      id: 3,
      title: 'SUSTAINABLE LUXURY',
      date: 'December 20, 2024',
      category: 'Eco-Friendly',
      image: 'https://images.pexels.com/photos/667838/pexels-photo-667838.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
      excerpt: 'Eco-friendly materials that look and feel premium.',
      fullContent: `Sustainability is no longer a niche; it is a necessity. But being eco-friendly does not mean compromising on luxury. In fact, some of the most exclusive materials today are sustainable.
      
      From bamboo silk rugs to reclaimed teak furniture and organic cotton textiles, we highlight the materials that are saving the planet while elevating your interior aesthetics.
      
      Why choose sustainable luxury?
      • Durability: High-quality natural materials often last longer than synthetics.
      • Health: Natural materials release fewer VOCs, improving indoor air quality.
      • Story: Reclaimed pieces come with a history and unique character.
      
      We are committed to sourcing materials that are as kind to the earth as they are beautiful in your home.`
    }
  ];


 const openPost = (post) => {
    console.log("Post clicked:", post.title); // Check your browser console for this!
    setSelectedPost(post);
    document.body.style.overflow = 'hidden'; 
  };
  const closePost = () => {
    setSelectedPost(null);
    document.body.style.overflow = 'auto'; // Restore scrolling
  };

  return (
    <section id="blog" className="blog-section">
      <div className="blog-header">
        <h2 className="section-title">LATEST INSIGHTS</h2>
        <div className="title-divider-gold"></div>
        <p className="section-subtitle">Trends, tips, and inspiration for your home.</p>
      </div>

      {/* --- GRID VIEW --- */}
      <div className="blog-grid">
        {blogPosts.map((post) => (
          <div key={post.id} className="blog-card" onClick={() => openPost(post)}>
            <div className="blog-img-wrapper">
              <img src={post.image} alt={post.title} />
              <span className="blog-category">{post.category}</span>
            </div>
            <div className="blog-content-preview">
              <span className="blog-date">{post.date}</span>
              <h3 className="blog-card-title">{post.title}</h3>
              <p className="blog-excerpt">{post.excerpt}</p>
              <button className="read-more-btn">READ ARTICLE &rarr;</button>
            </div>
          </div>
        ))}
      </div>

      {/* --- FULL PAGE OVERLAY (The "Page" View) --- */}
      {selectedPost && (
        <div className="blog-modal-overlay">
          <div className="blog-modal-content">
            
            {/* Close Button */}
            <button className="close-blog-btn" onClick={closePost}>
              &times; CLOSE ARTICLE
            </button>

            {/* Hero Image */}
            <div className="modal-hero-image">
              <img src={selectedPost.image} alt={selectedPost.title} />
            </div>

            {/* Article Content */}
            <div className="modal-article-container">
              <div className="modal-meta">
                <span className="modal-category">{selectedPost.category}</span>
                <span className="modal-date">{selectedPost.date}</span>
              </div>
              
              <h1 className="modal-title">{selectedPost.title}</h1>
              <div className="modal-divider"></div>
              
              <div className="modal-body-text">
                {selectedPost.fullContent.split('\n').map((paragraph, index) => (
                  <p key={index}>{paragraph}</p>
                ))}
              </div>

              {/* Footer of the article */}
              <div className="article-footer">
                <p>Enjoyed this article?</p>
                <button 
                  className="consult-btn"
                  onClick={() => {
                    closePost();
                    document.getElementById('contact').scrollIntoView({ behavior: 'smooth' });
                  }}
                >
                  DISCUSS YOUR PROJECT
                </button>
              </div>
            </div>
          
          </div>
        </div>
      )}
    </section>
  );
};

export default Blog;